import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CertonaService {
	private certonaRecommendationsSubject = new BehaviorSubject<any> (undefined);
	public certonaRecommendationsState = this.certonaRecommendationsSubject.asObservable();
	private resonanceReadySubject = new BehaviorSubject<any> (undefined);
	public resonanceReadyState = this.resonanceReadySubject.asObservable();
	private cartCertonaReadySubject = new BehaviorSubject<any> (undefined);
	public cartCertoneReadyState = this.cartCertonaReadySubject.asObservable();

	recommendations(certonaRecommendations: any) {
		this.certonaRecommendationsSubject.next({
			certonaRecommendations
		});
	}

	resonanceReady(isPLAEnabled: any) {
		this.resonanceReadySubject.next ({
			isPLAEnabled
		});
	}

	cartCertona(isCartCertona: any) {
		this.cartCertonaReadySubject.next ({
			isCartCertona
		});
	}
}
